import { useEffect, useState } from "react";
import { useUserStore } from "entities/user";
import { USER_ROLES } from "shared/config/routes";
import { ClientProfile } from "./ClientProfile";
import { ManagerProfile } from "./ManagerProfile";
import { getUserRequest } from "entities/user";
import { userStore } from "entities/user";
import styles from "../events-content/client-events/ClientEvents.module.scss";

export const LkProfilePage = () => {
  const { role } = useUserStore();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const loadUser = async () => {
      try {
        setLoading(true);
        setError(null);

        const user = await getUserRequest({ signal: controller.signal });
        if (!controller.signal.aborted && user) {
          userStore.setUser(user);
        }
      } catch (e) {
        if (e.name !== "AbortError" && !controller.signal.aborted) {
          setError(e);
          console.error(e);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    loadUser();

    return () => {
      controller.abort();
    };
  }, []);

  if (loading)
    return (
      <div className={styles.contentWrapper__stateBlock}>
        <p className={styles.contentWrapper__stateText}>Загрузка...</p>
      </div>
    );
  if (error)
    return (
      <div className={styles.contentWrapper__stateBlock}>
        <p className={styles.contentWrapper__stateText}>Ошибка загрузки</p>
      </div>
    );

  if (role === USER_ROLES.CLIENT) {
    return <ClientProfile />;
  }

  if (role === USER_ROLES.MANAGER) {
    return <ManagerProfile />;
  }

  return null;
};
